// extracted by mini-css-extract-plugin
module.exports = {"save":"styles_save__32aKG","cancel":"styles_cancel__a2JrC"};